<template>
    <v-row
        no-gutters
        class="pl-9 pt-8"
    >
        <v-col
            cols="9 pr-9"
        >
            <component
                :is="currentStep"
                :controller="controller"
            />
        </v-col>
        <v-col cols="3">
            <v-row
                class="n1 sidebar_block"
                no-gutters
                justify="center"
                align="center"
            >
                <v-col class="shrink">
                    <v-row
                        no-gutters
                        class="flex-nowrap"
                        align="center"
                    >
                        <v-col class="mr-3">
                            <v-icon color="primary">
                                mdi-book-open-blank-variant
                            </v-icon>
                        </v-col>
                        <v-col
                            class="primary--text body-2"
                            style="white-space: nowrap"
                        >
                            <a :href="HelpModule.getHelpLink('app_economic')" target="_blank">
                                {{ $t('How to set up') }}
                            </a>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import {computed, reactive, watch} from "@vue/composition-api";
import EconomicDialogImportStepsConnect from "./ImportSteps/EconomicDialogImportStepsConnect";
import EconomicDialogImportStepsImport from "./ImportSteps/EconomicDialogImportStepsImport";
import HelpModule from "@/modules/help/help";

import { STEPS } from "./model";
import AppStoreDialog from "../../../../store/modules/AppStoreDialog/appStoreDialog";
import Controller from "./controller";
import {$t} from "@/i18n";
import { Router } from "@/composables/Router";
import DialogModule from "@/store/modules/dialog";
import CustomFieldsModule from "@/store/modules/custom_fields";

export default {
    name: "EconomicDialogConnectTab",
    components: {
        EconomicDialogImportStepsConnect,
        EconomicDialogImportStepsImport,
    },
    props: {
        isSelected: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const { fetchCustomFields } = CustomFieldsModule();
        const appStoreDialog = AppStoreDialog()
        const { closeDialog } = DialogModule();
        const router = Router();

        const onImportDone = (importSessionId) => {
            let account_id = appStoreDialog.appStoreDialogGetters.getSelectedCompany().id;
            fetchCustomFields(account_id, 'client', 0, true);
            router.push({ name: 'import_result', params: { id: importSessionId }})
            closeDialog()
        }

        /** @type {Controller} */
        const controller = reactive(new Controller(appStoreDialog.appStoreDialogGetters.getSelectedCompany().id, onImportDone))

        const currentStep = computed(() => {
            if (controller.model.getStep() === STEPS.CONNECT) {
                return EconomicDialogImportStepsConnect
            } else if (controller.model.getStep() === STEPS.IMPORT) {
                return EconomicDialogImportStepsImport
            }
        })

        watch(() => props.isSelected, () => {
            const selectedTabOptions = appStoreDialog.appStoreDialogGetters.getSelectedTabOptions()
            if (props.isSelected && selectedTabOptions.showConnect) {
                controller.handleShowConnect()
            }
        })

        const selectedTabOptions = appStoreDialog.appStoreDialogGetters.getSelectedTabOptions()
        controller.loadState(selectedTabOptions.showConnect)

        return {
            controller,
            currentStep,
            HelpModule
        }
    }
};
</script>
